// App.jsx
import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Vpis from "./Vpis/Vpis";
import Profil from "./Profil/Profil";
import NotFound from "./Profil/NotFound";
import ProtectedRoute from "./ProtectedRoute";
import AdminRoute from "./AdminRoute";
import { getAccessToken } from "./api";
import KilometrinaMap from "./Profil/Kilometrina/KilometrinaMap";
import ObracunObresti from "./Profil/ObracunObresti/ObracunObresti";
import Stroskovnik from "./Profil/Stroskovnik/Stroskovnik";
import Pobotnica from "./Profil/Pobotnica/Pobotnica";
import PobotnicaIskanje from "./Profil/Pobotnica/PobotnicaIskanje";
import PregledDolznika from "./Profil/PregledDolznika/PregledDolznika";
import PodatkiUpnika from "./Profil/PodatkiUpnika/PodatkiUpnika";
import PodatkiDolznika from "./Profil/PodatkiDolznika/PodatkiDolznika";
import Rubezi from "./Profil/Rubezi/Rubezi";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";
import Podpora from "./Profil/Podpora/Podpora";
import NovPrimer from "./Profil/NovPrimer/NovPrimer";
import AdminUporabniki from "./Profil/AdminUporabniki/AdminUporabniki";
import Navodila from "./Profil/Navodila/Navodila";

function RootRedirect() {
    const token = getAccessToken();
    const location = useLocation();

    return token
        ? <Navigate to="/profil" replace />
        : <Navigate to="/vpis" replace state={{ from: location }} />;
}

export default function App() {
    const location = useLocation();

    const hideFooterOnRoutes = ["/vpis"];
    const hideFooter = hideFooterOnRoutes.some((path) =>
        location.pathname.startsWith(path)
    );

    const hideHeaderOnRoutes = ["/vpis"];
    const hideHeader = hideHeaderOnRoutes.some((path) =>
        location.pathname.startsWith(path)
    );

    return (
        <div className="app-shell notranslate" translate="no" lang="sl-SI">
            {!hideHeader && (
                <header>
                    <Header />
                </header>
            )}

            <main className="app-shell__content">
                <Routes>
                    <Route path="/" element={<RootRedirect />} />
                    <Route path="/vpis" element={<Vpis />} />

                    <Route path="/profil" element={<ProtectedRoute><Profil /></ProtectedRoute>} />

                    <Route path="/profil/novprimer" element={<ProtectedRoute><NovPrimer /></ProtectedRoute>} />

                    <Route path="/profil/admin/uporabniki" element={
                        <AdminRoute>
                            <AdminUporabniki />
                        </AdminRoute>
                    } />

                    <Route path="/profil/kilometrinamap" element={<ProtectedRoute><KilometrinaMap /></ProtectedRoute>} />
                    <Route path="/profil/obracunobresti" element={<ProtectedRoute><ObracunObresti /></ProtectedRoute>} />
                    <Route path="/profil/stroskovnik" element={<ProtectedRoute><Stroskovnik /></ProtectedRoute>} />

                    <Route path="/profil/pobotnica/iskanje" element={<ProtectedRoute><PobotnicaIskanje /></ProtectedRoute>} />
                    <Route path="/profil/pobotnica" element={<ProtectedRoute><Pobotnica /></ProtectedRoute>} />
                    <Route path="/profil/pobotnica/:id" element={<ProtectedRoute><Pobotnica /></ProtectedRoute>} />

                    <Route path="/profil/podpora" element={<ProtectedRoute><Podpora /></ProtectedRoute>} />
                    <Route path="/profil/navodila" element={<ProtectedRoute><Navodila /></ProtectedRoute>} />

                    <Route path="/profil/podatkiupnika" element={<ProtectedRoute><PodatkiUpnika /></ProtectedRoute>} />
                    <Route path="/profil/pregleddolznika" element={<ProtectedRoute><PregledDolznika /></ProtectedRoute>} />
                    <Route path="/profil/podatkidolznika" element={<ProtectedRoute><PodatkiDolznika /></ProtectedRoute>} />
                    <Route path="/profil/rubezi" element={<ProtectedRoute><Rubezi /></ProtectedRoute>} />

                    <Route path="*" element={<NotFound />} />
                </Routes>
            </main>

            {!hideFooter && <Footer />}
        </div>
    );
}